/**
 * 关键字常量
 * @author kk
 */

// 单字城市
export const SINGLE_WORD_CITIES = ['县'];

// 姓名称呼关键字
export const NAME_TITLES = ['先生', '小姐', '女士', '老师', '天猫', '旗舰店', '售后', '退货组'];

// 需要清洗的地址关键字
export const ADDRESS_CLEAN_KEYWORDS = [
    '请.*拒(收|签)?',
    '(不|拒|勿).*到付件?',
    '到付.*(不|拒)(收|签)',
    '(拒|不|建议).*(百世|极兔|信丰|京东|申通|圆通|中通|韵达|平邮|邮政|EMS|顺丰|到付|平邮|联昊通|丹鸟|安能|宅急送|国通)(快递|物流)?',
    '请?(寄|退)回.*(清单|产品)',
    '仓?库?签收.*处理',
    '感?谢.*配合',
    '建议使用官方推荐',
    '(支持.*)?上门取件(服务)?',
    '(详细|收货|收件|寄件|退货|发货|发件|寄回|售后|取件)?地址',
    '(收件|寄件|联系)?电(话|話)',
    '(手机|收件|寄件)号码',
    '所在地区',
    '联系人',
    '(寄|发|退|收)(回|出|件|货|方|\\：|:)(人|方|地)?\d*',
    '(姓名|名字)',
    '邮编',
    '(如?有赠品|人为损坏|已清洗|优先|安排|退款|订单|编号|旺旺名|您|写上)'
];

// 特殊市名处理
export const SPECIAL_CITY_NAMES = ['市辖区', '区', '县', '镇'];

// 小程序模式下需要重写的市名
export const MINIAPP_REWRITE_CITY_NAMES = ['市辖区'];